import React, { useState } from 'react';
import { Toast } from 'react-bootstrap';
import { IToastComponent } from '../../types/IToastComponent';
import './ToastComponent.scss';

// Toast component to call on API success/failure.
const ToastComponent = ({
  autohide,
  className,
  delay,
  icon,
  toastMessage,
}: IToastComponent) => {
  const [toast, setToast] = useState(true);
  const showToast = () => setToast(false);

  return (
    <Toast
      className="toast-wrapper"
      show={toast}
      delay={delay}
      autohide={autohide}
      onClose={showToast}
    >
      <Toast.Header className={className}>
        <div className="toast-icon">
          <img src={icon} alt="icon" />
        </div>

        <div className="me-auto">{toastMessage}</div>
      </Toast.Header>
    </Toast>
  );
};

export default ToastComponent;
